import React from "react";
import Dialog from "@material-ui/core/Dialog";
import styles from "./confOrder.module.css";
import TextField from "@material-ui/core/TextField";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import IconButton from "@material-ui/core/IconButton";
import Item from "./Item/Item";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import axios from "axios";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import { connect } from "react-redux";
import SelectComp from "../../utils/Select/SelectComp";
import SelectSearch from "../../utils/Selectsearch/SelectSearch";
import { getTaxes } from "../../../containers/app/actions";
import { setShowPartner } from "../../../containers/app/actions";
import { getAllPartner } from "../../../containers/app/actions";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";

const ConfOrder = (props) => {
  console.log("props", props.order);
  const [formData, setFormData] = React.useState({
    userId: props.user._id,
    orderNumber: 2,
    orderLocation: "",
    totalAmount: "",
    totalPayableAmount: "",
    partner: "",
    warehouse: "",
    orderFrom: "",
    orderType: "sales",
    deliveryAddress: "",
    truckNo: "",
    orderStatus: "New Order",
    orderDate: new Date().toISOString().slice(0, 10),
    orderId: "",
    driverNumber: "",
    paymentId:"",
    paymentMode:"",
    paymentStatus:"",
  });
  const [allLoads, setAllLoads] = React.useState([
    {
      item: "",
      type: "Product",
      quantity: 0,
      tax: "",
      taxAmount: 0,
      price: 0,
      availableQuantity: false,
      error: false,
      totalAmount: 0,
      discount: 0,
      stockSummary: false,
    },
  ]);
  const [loadErr, setLoadErr] = React.useState([
    { item: false, quantity: false, price: false, tax: false },
  ]);
  const [err, setErr] = React.useState({
    orderFrom: false,
    deliveryAddress: false,
    orderDate: false,
    partner: false,
    warehouse: false,
  });
  const [loading, setLoading] = React.useState(false);
  const [loadLoading, setLoadLoading] = React.useState(false);
  const [partners, setPartners] = React.useState(props.partners);
  const [selectedDate, setDate] = React.useState(moment());
  const [inputValue, setInputValue] = React.useState(
    moment().format("YYYY-MM-DD")
  );
  const [deletedList, setDeletedList] = React.useState([]);
  React.useEffect(() => {
    props.getAllPartner("ssssssssss");
  }, []);
  React.useEffect(() => {
    setPartners(props.partners);
  }, [props.partners]);
  React.useEffect(() => {
    if (!props.taxes) {
      props.getTaxes(props.user._id);
    }
  }, []);
  React.useEffect(() => {
    if (props.activePartner) {
      setFormData({
        ...formData,
        partner: props.activePartner,
        deliveryAddress: props.activePartner.address,
      });
    }
  }, [props.activePartner]);
  React.useEffect(() => {
    if (props.type == "EDIT") {
      console.log("Conf Order Page");
      let totalAmount = 0;
      // let allLoadData = [...props.order.allLoad];

      let allLoadData = props.order.allLoad.map((item) => {
        return { ...item };
      });
      let arr = allLoadData.map((val) => {
        return {
          ...val,
          oldQuantity: 1,
          item: {
            name:
              val.type == "Parts"
                ? val.item && val.item.partName
                : val.item && val.item.productName,
            orderItemType: val.type,
            subHeading: val.type,
            id: val.item && val.item._id,
            barcode:
              val.type == "Parts"
                ? val.item && val.item.parts_barcode
                : val.item && val.item.product_barcode,
            // productCost:  val.type == "Parts" ? 0 : val.item && val.item.productCost,
            productCost: val.type == "Parts" ? 0 : val.price,
            dealerPrice:
              val.type == "Parts" ? 0 : val.item && val.item.dealerPrice,
            distributorPrice:
              val.type == "Parts" ? 0 : val.item && val.item.distributorPrice,
          },
        };
      });
      let newArr = [];
      arr.forEach((val) => {
        if (newArr.length == 0) {
          newArr.push({ ...val, ids: [val._id] });
        } else {
          let added = false;
          newArr.forEach((newVal, index) => {
            if (newVal.item.id == val.item.id && val.status == newVal.status) {
              newArr[index] = {
                ...val,
                ids: [...newArr[index].ids, val._id],
                quantity: newArr[index].quantity + 1,
                oldQuantity: newArr[index].oldQuantity + 1,
              };
              added = true;
            }
            if (index + 1 == newArr.length && !added) {
              newArr.push({ ...val, ids: [val._id] });
            }
          });
        }
      });

      setFormData({
        ...formData,
        ...props.order,
        orderId: props.order._id,
        totalAmount,
        warehouse: props.order.warehouse,
        partner: props.order.partner,
      });

      setAllLoads([...newArr]);
    }
  }, [props.order, props.plants, partners, props.taxes]);

  const onDateChange = (date, value) => {
    setFormData({ ...formData, orderDate: value });

    setDate(date);
    setInputValue(value);
  };

  const dateFormatter = (str) => {
    return str;
  };

  const hanldeDelete = (valIndex) => {
    let arr = allLoads;
    arr = arr.filter((val, index) => {
      return index != valIndex;
    });
    setAllLoads([...arr]);
  };

  const handleAdd = () => {
    let arr = allLoads;
    let err = loadErr;
    arr.push({
      item: "",
      type: "Product",
      quantity: 0,
      tax: props.taxes[0],
      taxAmount: 0,
      availableQuantity: false,
      error: false,
      price: 0,
      oldQuantity: 0,
      totalAmount: 0,
      discount: 0,
      stockSummary: false,
    });
    err.push({ item: false, quantity: false, price: false, tax: false });

    setLoadErr([...loadErr]);
    setAllLoads([...arr]);
  };

  const handleProductChange = (index, data, key) => {
    console.log("checkhandle");
    console.log(index);
    console.log(data);
    console.log(key);
    if (formData.orderType == "sales" && formData.orderFrom == "") {
      props.setAlert("Select a warehouse to continue");
    } else if (formData.orderType == "sales" && formData.partner == "") {
      props.setAlert("Select a partner to continue");
    } else {
      console.log("handle product change");
      let arr = [...allLoads];
      if (data) arr[index][key] = data;
      console.log("arr");
      console.log(arr);
      if (key == "item") {
        if (formData.orderType == "sales") {
          // console.log('orderType  Sales');
          // if (formData.partner.type == "Dealer") {
          //   arr[index]["price"] = data.dealerPrice;
          //   // console.log('price Dealer:' + arr[index]["price"]);
          // } else {
          //   arr[index]["price"] = data.distributorPrice;
          //   // console.log('price Distributor:' + arr[index]["price"]);
          // }
          arr[index]["type"] = data.orderItemType;
          arr[index]["discount"] = formData.partner.discount;
        } else {
          console.log("orderType  Purchase:");
          // console.log(data);
          arr[index]["price"] = data.productCost;
          // arr[index]["price"] = data.CnF;
          // console.log('price productCost:' + arr[index]["price"]);
          arr[index]["type"] = data.orderItemType;
        }
        // console.log('tax g');
        if (props.type != "EDIT") {
          arr[index]["tax"] = props.taxes[0];
        }
        // console.log('tax z');
        // console.log(arr[index]["tax"]);
        if (formData.orderType == "sales") {
          console.log("check");
          fetchSummary(
            index,
            formData.orderFrom._id,
            data.orderItemType,
            data.id
          );
          // fetchQuantity(
          //   index,
          //   formData.orderFrom._id,
          //   data.orderItemType,
          //   data.id
          // );
        }
      }
      // console.log('HandleProductChange:');
      setAllLoads([...arr]);
    }
  };
  const fetchSummary = (index, warehouseId, itemType, itemId) => {
    setLoadLoading(index);
    axios({
      method: "post",
      url: "/getWarehousePartSummary",
      data: {
        warehouse: warehouseId,
        objectType: itemType == "Parts" ? "Part" : "Product",
        objectId: itemId,
      },
    })
      .then((res) => {
        console.log("res summary");
        console.log(res);
        console.log(res.data.success);
        console.log(res.data.data);
        if (res.data.success) {
          console.log("here success");
          handleProductChange(index, res.data.data, "stockSummary");
        } else {
          console.log("here fail");
          handleProductChange(index, false, "stockSummary");
        }
        setLoadLoading(false);
      })
      .catch((err) => {
        setLoadLoading(false);
        console.log("C4 Handle call");
        handleProductChange(index, false, "stockSummary");
      });
  };

  const fetchQuantity = (index, warehouseId, itemType, itemId) => {
    console.log("FetchQuantity");
    setLoadLoading(index);
    axios({
      method: "post",
      url: "/getWarehousePartQuantity",
      data: {
        warehouseId,
        itemType,
        itemId,
      },
    })
      .then((res) => {
        console.log("C Handle call");
        if (res.data.success) {
          if (res.data.quantity == 0) {
            console.log("C1 Handle call");
            handleProductChange(index, "NO_DATA", "availableQuantity");
          } else {
            let qty = res.data.quantity;
            let orderQuantity = 0;
            let checked = false;
            allLoads.forEach((val, index) => {
              if (val.item.id == itemId) {
                if (val.quantity) {
                  if (props.type == "EDIT") {
                    orderQuantity += val.quantity - val.oldQuantity;
                  } else orderQuantity += val.quantity;
                }
              }
              if (allLoads.length == index + 1) {
                // console.log(orderQuantity)
                if (qty - orderQuantity < 1) {
                  // console.log("NO data");
                  // console.log('C2 Handle call');
                  handleProductChange(index, "NO_DATA", "availableQuantity");
                } else {
                  // console.log("yes")
                  // console.log(qty - orderQuantity)
                  // console.log('C3 Handle call');
                  handleProductChange(
                    index,
                    qty - orderQuantity,
                    "availableQuantity"
                  );
                }
              }
            });
          }
        } else {
          // console.log('C4 Handle call');
          handleProductChange(index, "NO_DATA", "availableQuantity");
        }
        setLoadLoading(false);
      })
      .catch((err) => {
        setLoadLoading(false);
        console.log("C4 Handle call");
        handleProductChange(index, "NO_DATA", "availableQuantity");
      });
  };

  console.log("edit order allLoads");
  console.log(allLoads);

  const validate = () => {
    let validData = true;
    let error = { orderFrom: false, orderType: false, deliveryAddress: false };

    let lErr = Array(allLoads.length).fill({
      item: false,
      quantity: false,
      price: false,
      tax: false,
    });

    setErr({ ...err, ...error });
    setLoadErr([...lErr]);

    Object.keys(error).map((key) => {
      if (formData[key] == "") {
        error[key] = "Field cannot be empty";
        validData = false;
      }

      if (formData.orderType == "sales") {
        if (formData.partner == "") {
          error["orderFrom"] = "Field cannot be empty";
          validData = false;
        }
      } else {
        if (formData.warehouse == "") {
          error["orderFrom"] = "Field cannot be empty";
          validData = false;
        }
      }

      if (allLoads.length == 0) {
        props.setAlert("Add Atleast one product / part");
        validData = false;
      }
    });

    allLoads.forEach((val, index) => {
      if (val.item == "") {
        lErr[index].item = "Field cannot be empty";
        validData = false;
      }
      if (val.quantity == "") {
        lErr[index].quantity = "Field cannot be empty";
        validData = false;
      }
      if (val.price == "") {
        lErr[index].price = "Field cannot be empty";
        validData = false;
      }
      if (val.tax == "") {
        lErr[index].tax = "Field cannot be empty";
        validData = false;
      }
    });

    setLoadErr([...lErr]);
    setErr({ ...error });
    return validData;
  };

  const onSubmit = () => {
    if (validate()) {
      setLoading(true);

      const url = props.type == "EDIT" ? "/editOrder" : "/addOrder";
      const key = formData.orderType == "sales" ? "partnerId" : "warehouseId";
      const value =
        formData.orderType == "sales"
          ? formData.partner && formData.partner._id
          : formData.warehouse && formData.warehouse._id;
      const delList = deletedList;

      const allLoadConf = [];
      allLoads.forEach((val) => {
        if (val.ids) {
          Array(parseInt(val.quantity))
            .fill("")
            .forEach((newVal, index) => {
              let newData = {
                ...val,
                item: val.item.id,
                quantity: 1,
                _id: val.ids[index] ? val.ids[index] : "DELETE",
              };
              if (newData._id == "DELETE") delete newData._id;

              allLoadConf.push(newData);
            });

          if (val.quantity < val.ids.length) {
            let deletedItem = val.quantity - val.ids.length;
            delList.push(...val.ids.slice(deletedItem));
          }
        } else {
          allLoadConf.push({ ...val, item: val.item.id });
        }
      });

      axios({
        method: "post",
        url: url,
        headers: {"Access-Control-Allow-Origin": "*"},
        data: {
          ...formData,
          allLoad: allLoadConf,
          [key]: value,
          orderFrom: formData.orderFrom && formData.orderFrom._id,
          orderFromRef:
            formData.orderType == "sales" ? "Warehouse" : "ManufacturingPlant",
          deletedList: delList,
        },
      })
        .then((res) => {
          if (res.data.success) {
            props.onDone();
            setLoading(false);
            props.setAlert("Succesfully Done");
            setFormData({
              userId: props.user._id,
              orderNumber: 2,
              orderLocation: "",
              totalAmount: "",
              partner: "",
              plantId: "",
              tax: "",
              orderType: "sales",
              deliveryAddress: "",
              truckNo: "",
              orderStatus: "New Order",
              driverNumber: "",
              orderDate: false,
              orderId: "",
            });
            setAllLoads([
              {
                item: "",
                type: "Product",
                quantity: 1,
                tax: "",
                taxAmount: 0,
                price: 0,
                totalAmount: 0,
              },
            ]);
          } else {
            setLoading(false);
            props.setAlert(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          props.setAlert("Something went wrong !Try Again");
        });
    }
  };
  let btnText = props.type == "EDIT" ? "Update Order" : "Add Order";
  let newMenuList =
    formData.orderType == "sales"
      ? partners
        ? partners.filter((val) => val.status == "Active")
        : []
      : props.warehouse;

  let nameValue =
    formData.orderType == "sales" ? formData.partner : formData.warehouse;

  let orderFromList =
    formData.orderType == "sales"
      ? props.warehouse
      : props.plants.filter((val) => val.status == "Active");

  let dataList = [];
  props.products.forEach((val) => {
    if (val.status == "Active") {
      dataList.push({
        id: val._id,
        name: val.productName,
        orderItemType: "Product",
        subHeading: "Product",
        productCost: val.CnF,
        dealerPrice: val.dealerPrice,
        distributorPrice: val.distributorPrice,
        quantity: 1,
        barcode: val.product_barcode,
      });
    }
  });

  props.parts.forEach((val) => {
    if (val.status == "Active") {
      dataList.push({
        id: val._id,
        name: val.partName,
        orderItemType: "Parts",
        subHeading: "Part",
        quantity: 1,
        dealerPrice: 0,
        distributorPrice: 0,
        barcode: val.parts_barcode,
        productCost: 0,
      });
    }
  });
  let totalAmount = 0;
  allLoads.forEach((val) => {
    let caluculatedTax = 0;
    let caluculatedTotal = 0;

    if (val.tax)
      caluculatedTax =
        (parseInt(val.tax.gst) / 100) * (val.price * val.quantity);
    else caluculatedTax = val.taxAmount;

    if (val.totalAmount == 0 && val.tax) {
      caluculatedTotal = val.price * val.quantity + caluculatedTax;
      caluculatedTotal =
        caluculatedTotal - (caluculatedTotal / 100) * val.discount;
    } else caluculatedTotal = val.totalAmount;

    totalAmount += parseInt(caluculatedTotal);
  });
  var text, textVal;
  props.user.userType.toLowerCase() === "Admin".toLowerCase()
    ? (text = ["Sales", "Purchase"])
    : props.user.userType.toLowerCase() === "Sales".toLowerCase()
    ? (text = ["Sales"]): props.user.userType.toLowerCase() === "Warehouse".toLowerCase()
    ? (text = ["Sales","Purchase"])
    : (text = ["Purchase"]);
  props.user.userType.toLowerCase() === "Admin".toLowerCase()
    ? (textVal = ["sales", "purchase"])
    : props.user.userType.toLowerCase() === "Sales".toLowerCase()
    ? (textVal = ["sales"]) : props.user.userType.toLowerCase() === "Warehouse".toLowerCase()
    ? (textVal = ["sales","purchase"])
    : (textVal = ["purchase"]);

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      scroll={"paper"}
      maxWidth={"xl"}
      fullWidth={true}
    >
      <div className={styles.container}>
        <div className={styles.containerContent}>
          <div className={styles.header}>
            <h1>{btnText}</h1>

            <div className={styles.buttons}>
              <IconButton onClick={props.onClose}>
                <CloseRoundedIcon />
              </IconButton>
            </div>
          </div>

          <h2>Details</h2>

          <div className={styles.content}>
            <div className={styles.row}>
              <SelectComp
                label="Order Type"
                variant="outlined"
                className={styles.textField}
                value={formData.orderType}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    orderType: e.target.value,
                    orderFrom: "",
                    partner: "",
                    warehouse: "",
                  })
                }
                options={text}
                values={textVal}
                error={err.orderType}
                helperText={err.orderType}
              />
              <SelectSearch
                variant="outlined"
                className={styles.textField}
                label={`Order From - ${
                  formData.orderType == "sales" ? "Warehouse" : "Manufacturing"
                }`}
                value={formData.orderFrom}
                onChange={(value) =>
                  setFormData({ ...formData, orderFrom: value })
                }
                keyCode="name"
                options={orderFromList}
                subHeading={
                  formData.orderType == "sales"
                    ? "Warehouse"
                    : "Manufacturing Plant"
                }
                error={err.orderFrom}
                helperText={err.orderFrom}
              />
            </div>

            <div className={styles.row}>
              <SelectSearch
                variant="outlined"
                className={styles.textField}
                label={`Order To - ${
                  formData.orderType == "sales" ? "Partner" : "Warehosue"
                }`}
                value={nameValue}
                onChange={(value) => {
                  if (formData.orderType == "sales") {
                    setFormData({
                      ...formData,
                      partner: value,
                      deliveryAddress: value && value.address,
                    });
                  } else {
                    setFormData({
                      ...formData,
                      warehouse: value,
                      deliveryAddress: value && value.address,
                    });
                  }
                }}
                keyCode="name"
                options={newMenuList}
                subHeading={
                  formData.orderType == "sales" ? "Patner" : "Warehosue"
                }
                addIcon={formData.orderType == "sales" ? true : false}
                onAdd={() => props.setShowPartner(true)}
                onAddName="Add New Partner"
                error={err.orderFrom}
                helperText={err.orderFrom}
              />
              <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
                <KeyboardDatePicker
                  autoOk={true}
                  className={styles.textField}
                  label="Creation Date"
                  inputVariant="outlined"
                  value={selectedDate}
                  format="YYYY-MM-DD"
                  onChange={onDateChange}
                  rifmFormatter={dateFormatter}
                  minDate={moment().subtract(6, "months")}
                  maxDate={moment()}
                  InputLabelProps={{ shrink: true, required: true }}
                  inputValue={inputValue}
                />
              </MuiPickersUtilsProvider>
            </div>

            <div className={styles.row}>
              <SelectComp
                variant="outlined"
                className={styles.textField}
                label="Status"
                value={formData.orderStatus}
                onChange={(e) =>
                  setFormData({ ...formData, orderStatus: e.target.value })
                }
                options={[
                  "New Order",
                  "Confirm Order",
                  "Ready For Dispatch",
                  "Dispatched",
                  "Delivered",
                ]}
                values={[
                  "New Order",
                  "Confirm Order",
                  "Ready For Dispatch",
                  "Dispatched",
                  "Delivered",
                ]}
                error={err.orderStatus}
                helperText={err.orderStatus}
              />

              <TextField
                variant="outlined"
                className={styles.textField}
                label="Total Amount"
                disabled
                value={formData.totalPayableAmount}
                onChange={(e) =>
                  setFormData({ ...formData, totalPayableAmount: e.target.value })
                }
                error={err.totalAmount}
                helperText={err.totalAmount}
              />
            </div>

            <div className={styles.row}>
              <TextField
                variant="outlined"
                className={styles.textField}
                label="Truck #"
                value={formData.truckNo}
                onBlur={(e) =>
                  setFormData({ ...formData, truckNo: e.target.value.trim() })
                }
                onChange={(e) =>
                  setFormData({ ...formData, truckNo: e.target.value })
                }

                // error={err.truckNo}
                // helperText={err.truckNo}
              />

              <TextField
                variant="outlined"
                className={styles.textField}
                label="Delivery address"
                value={formData.deliveryAddress}
                onBlur={(e) =>
                  setFormData({
                    ...formData,
                    deliveryAddress: e.target.value.trim(),
                  })
                }
                onChange={(e) =>
                  setFormData({ ...formData, deliveryAddress: e.target.value })
                }
                error={err.deliveryAddress}
                helperText={err.deliveryAddress}
              />
            </div>

            <div className={styles.row}>
              <TextField
                variant="outlined"
                className={styles.textField}
                label="Driver Number"
                value={formData.driverNumber}
                onBlur={(e) =>
                  setFormData({
                    ...formData,
                    driverNumber: e.target.value.replace(/\D/, "").trim(),
                  })
                }
                onChange={(e) => {
                  e.target.value.length <= 10 &&
                    setFormData({
                      ...formData,
                      driverNumber: e.target.value.replace(/\D/, ""),
                    });
                }}

                //error={err.driverNumber}
                //helperText={err.driverNumber}
              />

              <TextField
                variant="outlined"
                className={styles.textField}
                label="Location"
                value={formData.orderLocation}
                onBlur={(e) =>
                  setFormData({
                    ...formData,
                    orderLocation: e.target.value.trim(),
                  })
                }
                onChange={(e) =>
                  setFormData({ ...formData, orderLocation: e.target.value })
                }

                //error={err.orderLocation}
                //helperText={err.orderLocation}
              />
            </div>
          </div>
          <div className={styles.header}>
            <h2>Payment Details</h2>
          </div>
          <div className={styles.row}>
            <TextField
                variant="outlined"
                className={styles.textField}
                label="Payment Mode"
                disabled
                value={formData.paymentMode}
            />
            <TextField
                variant="outlined"
                className={styles.textField}
                label="Payment Status"
                disabled
                value={formData.paymentStatus}
            />      
          </div>
          <div className={styles.row}>
              <TextField
                variant="outlined"
                className={styles.textField}
                label="Online Payment Id"
                disabled
                value={formData.paymentId}
            />
            <TextField
                variant="outlined"
                className={styles.textField}
                label="Delivery Charges"
                disabled
                value={formData.deliveryCharge}
            />
          </div>
          <div className={styles.row}>      
            <TextField
                variant="outlined"
                className={styles.textField}
                label="Online Payment Collected"
                disabled
                value={formData.paymentCollected}
            />
          </div>
          <div className={styles.header}>
            <h2>Order Items</h2>
            {/* <IconButton onClick={handleAdd}>
                            <AddRoundedIcon />
                        </IconButton> */}
          </div>

          {allLoads.map((val, index) => {
            return (
              <Item
                values={val}
                index={index}
                dataList={dataList}
                key={index}
                onDelete={() => {
                  hanldeDelete(index);
                  let arr = deletedList;
                  arr.push(val._id);
                  setDeletedList(arr);
                }}
                onChange={(value, key) =>
                  handleProductChange(index, value, key)
                }
                taxList={props.taxes}
                loading={loadLoading}
                orderType={formData.orderType}
                type={props.type}
                error={loadErr[index]}
                type={props.type}
              />
            );
          })}
          <div className={styles.footer}>
            <IconButton onClick={handleAdd}>
              <AddRoundedIcon />
            </IconButton>
          </div>
          <Divider />
          <div className={styles.footer}>
            {loading ? (
              <Button variant="contained" color="secondary">
                Loading....
              </Button>
            ) : (
              <Button variant="contained" color="secondary" onClick={onSubmit}>
                {btnText}
              </Button>
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  user: state.appReducer.user,
  taxes: state.appReducer.taxes,
  activePartner: state.appReducer.activePartner,
  partners: state.appReducer.partners,
});
export default connect(mapStateToProps, {
  getTaxes,
  setShowPartner,
  getAllPartner,
})(ConfOrder);

let arr = [
  { id: 1, name: "name", num: 10 },
  { id: 2, name: "name", num: 10 },
  { id: 3, name: "one", num: 10 },
];
